import { render, staticRenderFns } from "./SupplierPurchaseGoalList.vue?vue&type=template&id=3f897fb7"
import script from "./SupplierPurchaseGoalList.vue?vue&type=script&lang=js"
export * from "./SupplierPurchaseGoalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports